import React, { useState, useEffect } from "react";

import { editorialAppointmentsDb } from "../../../db/dbClasses";
import { BoxDiv } from "../../Miscellaneous/FancyDiv.component";
import NumberedList from "../../Miscellaneous/NumberedList.component";
import Header from "../../Miscellaneous/Header.component";
import SubHeader from "../../Miscellaneous/SubHeader.component";
import CardDeck from "react-bootstrap/CardDeck";

export default function EditorialAppointments() {
  const [editorialAppointments, setEditorialAppointments] = useState([]);

  const getData = async () => {
    let appointments = await editorialAppointmentsDb.read();
    setEditorialAppointments(appointments);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="p-0 font-open-sans" style={{ minHeight: "100vh" }}>
      <Header content="Editorial Appointments" />
      <BoxDiv>
        <div className="w-100 p-5 pt-2">
          <SubHeader
            id="editorial-appointments"
            content="Current Appointments"
          />
          <div className="w-100 mx-auto p-4">
            <CardDeck>
              <NumberedList list={editorialAppointments} searchKey="contents" />
            </CardDeck>
          </div>
        </div>
      </BoxDiv>
    </div>
  );
}
